import { Box, Tooltip, Typography, TypographyOwnProps } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Duration_Type_Enum, Maybe } from '@kheops/graphql';
import { useTranslation } from 'react-i18next';

interface ShelfLifeDurationDisplayProps {
  duration?: Maybe<number>;
  durationType?: Maybe<Duration_Type_Enum>;
  titleVariant?: TypographyOwnProps['variant'];
  titleAndValueGap?: number;
  valueTypographyVariant?: TypographyOwnProps['variant'];
}

export default function ShelfLifeDurationDisplay({ duration, durationType, titleVariant, titleAndValueGap, valueTypographyVariant }: ShelfLifeDurationDisplayProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'products']);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: titleAndValueGap ?? 1,
      }}
    >
      <Typography variant={titleVariant}>{t('products:shelf_life')}</Typography>
      {durationType
        ? (
          <Box
            sx={{
              display: 'flex',
              gap: 0.5,
            }}
          >
            <Typography variant={valueTypographyVariant}>
              {duration} {t(`common:${durationType.toLowerCase()}`, { count: duration! }).toLowerCase()}
            </Typography>
            <Tooltip sx={{ ml: 0.5 }} title={t('products:shelf_life_duration_helper')}>
              <InfoOutlinedIcon fontSize="small" />
            </Tooltip>
          </Box>
        )
        : (
          <Typography variant={valueTypographyVariant}>{t('common:not_filled')}</Typography>
        )}
    </Box>
  );
}
